package com.wintermar.inspection.core.domain

sealed class FlowBatchResult<T>(
    val data: T? = null,
    val error: Throwable? = null,
) {
    class Success<T>(data: T?) : FlowBatchResult<T>(data = data)
    class Error<T>(error: Throwable?) : FlowBatchResult<T>(error = error)
    class Completed<T>(data: T?) : FlowBatchResult<T>(data = data)
    class FirstProcess<T>(data: T?) : FlowBatchResult<T>(data = data)
}
